import { Right } from "@insightfulscience/shared-utils/either";

/** @type {
	(setId: string, plasmidId: string) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<Right<string>>
} */
const getPlasmidContentMap =
	(setId, plasmidId) =>
	({ sgApiClient }) =>
		sgApiClient.getPlasmidContentMap(setId, plasmidId).then(Right);

export default getPlasmidContentMap;
